import { rand } from "./array-randomizer";

const creatureNameSyllables = [
  [
    "Ael",
    "Ar",
    "At",
    "Af",
    "Am",
    "Ain",
    "Bo",
    "Baf",
    "Bet",
    "Bin",
    "Buk",
    "Bon",
    "Bru",
    "Cal",
    "Cor",
    "Cen",
    "Col",
    "De",
    "Dra",
    "Din",
    "Deo",
    "Dak",
    "Dot",
    "Er",
    "Eo",
    "Eni",
    "Eto",
    "Eal",
    "Eth",
    "Emi",
    "Eos",
    "Foh",
    "Fel",
    "Fan",
    "Fri",
    "Fik",
    "Faw",
    "Flo",
    "Gru",
    "Gon",
    "Gas",
    "Gy",
    "Gli",
    "Gea",
    "Got",
    "Hun",
    "Hol",
    "Hra",
    "Hib",
    "Had",
  ],
  [
    "Hu",
    "Hol",
    "Has",
    "Hof",
    "Hev",
    "Io",
    "Im",
    "Ir",
    "Iok",
    "Iv",
    "Ix",
    "Jo",
    "Je",
    "Jun",
    "Jas",
    "Jho",
    "Jen",
    "Jiv",
    "Jox",
    "Jer",
    "Jis",
    "Kro",
    "Ke",
    "Kal",
    "Koe",
    "Klu",
    "Kyn",
    "Kva",
    "Kol",
    "Kes",
    "Kut",
    "Kso",
    "Kae",
    "Kib",
    "Li",
    "Lon",
    "Ler",
    "La",
    "Loy",
    "Lun",
    "Les",
    "Lam",
    "Lef",
    "Luz",
    "Lop",
    "Mo",
    "Met",
    "Maf",
    "Mig",
    "Mox",
  ],
  [
    "Mus",
    "Myn",
    "Med",
    "Mol",
    "Mec",
    "Nio",
    "Nu",
    "Ner",
    "Nas",
    "Or",
    "Otu",
    "Owa",
    "Ogi",
    "Ofe",
    "Ovy",
    "Olo",
    "Oma",
    "Pro",
    "Pem",
    "Pas",
    "Pu",
    "Puc",
    "Pyf",
    "Piz",
    "Qu",
    "Reo",
    "Rin",
    "Ra",
    "Rol",
    "Se",
    "Sov",
    "Sag",
    "Siz",
    "Suf",
    "To",
    "Til",
    "Tra",
    "Tuv",
    "Uo",
    "Un",
    "Ven",
    "Vo",
    "Vas",
    "Xa",
    "Xon",
    "Yeo",
    "Yl",
    "Yt",
    "Zas",
    "Zo",
  ],
];

export const generateRandomCreatureName = () => {
  const syllableCount = Math.floor(Math.random() * 3) + 1;
  const result = [];

  if (syllableCount >= 1) {
    result.push(rand(creatureNameSyllables[0]));
  }
  if (syllableCount >= 2) {
    result.push(rand(creatureNameSyllables[1]));
  }
  if (syllableCount === 3) {
    result.push(rand(creatureNameSyllables[2]));
  }

  return result.join("").toLowerCase();
};
